import { useState, useEffect } from "react";
import { ChevronLeft } from "lucide-react";
import { C } from "./data";
import { Serif, Label } from "./ui";
import { getNotices } from "./consumerAuth";

const CHIP = { Welcome: C.green, Action: C.red, Notice: C.slate, Product: C.navy };

export default function Notices() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { getNotices().then((d) => d?.items?.length && setItems(d.items)).catch((e) => console.error("notices load failed", e)); }, []);
  const n = items.find((x) => x.id === open);

  if (n) {
    return (
      <div style={{ padding: "24px 22px 30px" }} data-testid="consumer-notice-detail">
        <button onClick={() => setOpen(null)} data-testid="notice-back" style={{ display: "inline-flex", alignItems: "center", gap: 5, background: "none", border: 0, color: C.slate, fontSize: 13, cursor: "pointer", marginBottom: 18 }}>
          <ChevronLeft size={16} /> All notices
        </button>
        <span style={{ display: "inline-block", padding: "4px 10px", borderRadius: 999, background: `${CHIP[n.type] || C.slate}18`, color: CHIP[n.type] || C.slate, fontSize: 11, fontWeight: 700, marginBottom: 12 }}>{n.type}</span>
        <Serif size={24} style={{ marginBottom: 6, overflowWrap: "anywhere" }}>{n.title}</Serif>
        <Label style={{ marginBottom: 18 }}>{n.date}</Label>
        <p style={{ fontSize: 15, color: C.ink, lineHeight: 1.65, overflowWrap: "anywhere", whiteSpace: "pre-line" }}>{n.body}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "24px 22px 30px" }} data-testid="consumer-notices">
      <Label>Notices</Label>
      <Serif size={26} style={{ margin: "5px 0 4px" }}>Your <em style={{ color: C.slate }}>inbox</em>.</Serif>
      <div style={{ fontSize: 12, color: C.slate, marginBottom: 20 }}>Updates and reminders from ResQ1 — never emergencies.</div>

      {items.map((x) => (
        <div key={x.id} onClick={() => setOpen(x.id)} data-testid={`notice-${x.id}`}
          style={{ display: "flex", gap: 12, padding: 14, background: "#fff", border: "1px solid rgba(26,30,36,0.07)", borderRadius: 11, marginBottom: 8, cursor: "pointer" }}>
          <span style={{ width: 9, height: 9, borderRadius: "50%", background: x.unread ? C.red : "transparent", marginTop: 6, flexShrink: 0 }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: CHIP[x.type] || C.slate, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{x.type}</span>
              <span style={{ fontSize: 11, color: C.slate, fontFamily: "'JetBrains Mono', monospace", flexShrink: 0 }}>{x.date}</span>
            </div>
            <div style={{ fontSize: 14, fontWeight: x.unread ? 700 : 500, color: C.ink, marginTop: 3, lineHeight: 1.35, overflowWrap: "anywhere" }}>{x.title}</div>
            <div style={{ fontSize: 12, color: C.slate, marginTop: 4, lineHeight: 1.5, overflowWrap: "anywhere", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{x.body}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
